const VJ_CAMPAIGN = "rn_vj";

export const PROMO_CONSTANTS = {
  // Attribution for /hire requests originating from the W2A promo, matching the
  // `from=w2a-${campaign}` convention used for the open-app onelink (see RXP-74).
  // Relative so the browser resolves it against the current origin (this CTA only
  // renders on web), mirroring the relative `/hire` link in the mosaic promos service.
  EMPLOYER_CTA_URL: `/hire?from=w2a-${VJ_CAMPAIGN}`,
  VJ_CAMPAIGN,
  VJ_HOST_ID: "jobsearch" as const,
  VJ_PAGE_ID: "viewjob" as const,
};

/**
 * Relevant proctor test names for web to app promo
 * Add test names here when proctor tests are available
 * Related IQL indexes show only these tsts
 */
export const RELEVANT_TEST_NAMES: string[] = ["jsj_rn_mob_vj_offsite_w2a_promo_tst"];
